var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.5V52.5M25 50L35 45M25 45L35 50M12.5 42.5V52.5M7.5 50L17.5 45M7.5 45L17.5 50M47.5 42.5V52.5M42.5 50L52.5 45M42.5 45L52.5 50M17.5 35C17.5 33.6739 18.0268 32.4021 18.9645 31.4645C19.9021 30.5268 21.1739 30 22.5 30H37.5C38.8261 30 40.0979 30.5268 41.0355 31.4645C41.9732 32.4021 42.5 33.6739 42.5 35M22.5 15C22.5 16.9891 23.2902 18.8968 24.6967 20.3033C26.1032 21.7098 28.0109 22.5 30 22.5C31.9891 22.5 33.8968 21.7098 35.3033 20.3033C36.7098 18.8968 37.5 16.9891 37.5 15C37.5 13.0109 36.7098 11.1032 35.3033 9.6967C33.8968 8.29018 31.9891 7.5 30 7.5C28.0109 7.5 26.1032 8.29018 24.6967 9.6967C23.2902 11.1032 22.5 13.0109 22.5 15Z",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordUser);
export default __webpack_public_path__ + "static/media/password-user.f2cbed1019abd9c33dd62abd1b88f95b.svg";
export { ForwardRef as ReactComponent };